import {
  Button,
  Divider,
  Drawer,
  Popconfirm,
  Space,
  Table,
  TableProps,
  Typography,
  message,
} from 'antd'
import dayjs from 'dayjs'
import { memo, useCallback, useEffect, useRef, useState } from 'react'

import { deletePackage, getPackage } from '~/services/package'
import { IPackage } from '~/types/package'

import ModalForm from './ModalForm'
import { Container } from './style'

const Index = () => {
  const [loading, setLoading] = useState(false)
  const [dataSource, setDataSource] = useState<IPackage[]>([])
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [drawerFormData, setDrawerFormData] = useState<Partial<IPackage>>({})

  const pageRef = useRef({
    page: 1,
    size: 10,
  })

  const fetchData = useCallback(() => {
    setLoading(true)
    getPackage(pageRef.current.page, pageRef.current.size)
      .then((res) => {
        console.log(res)
        setDataSource(res.data?.content || [])
      })
      .catch((err) => {
        message.error(err?.message || '请求错误，请稍后再试')
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const onSearch = useCallback(() => {
    fetchData()
  }, [fetchData])

  const columns = useRef<TableProps<IPackage>['columns']>([
    {
      title: '套餐名',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      fixed: 'left',
    },
    {
      title: '有效期',
      dataIndex: 'validity',
      key: 'validity',
      width: 100,
    },
    {
      title: '有效期描述',
      dataIndex: 'validityDescription',
      key: 'validityDescription',
      width: 200,
    },
    {
      title: '折扣',
      dataIndex: 'discount',
      key: 'discount',
      width: 150,
    },
    {
      title: '价格',
      dataIndex: 'price',
      key: 'price',
      width: 150,
      render: (text) => `¥ ${(text / 100).toFixed(2)}`,
    },

    {
      title: '折后价格',
      dataIndex: 'priceAfterDiscount',
      key: 'priceAfterDiscount',
      width: 150,
      render: (text) => `¥ ${(text / 100).toFixed(2)}`,
    },
    {
      title: '次数',
      dataIndex: 'count',
      key: 'count',
      width: 150,
    },
    {
      title: '排序',
      dataIndex: 'order',
      key: 'order',
      width: 100,
    },
    {
      title: '是否试用卡',
      dataIndex: 'trial',
      key: 'trial',
      width: 100,
      render: (text) => (text ? '是' : '否'),
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: 150,
      render: (text, record) =>
        record.status === 'ENABLED' ? '已启用' : '已禁用',
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
      width: 200,
    },
    {
      title: '更新时间',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (text) => dayjs(text).format('YYYY-MM-DD HH:mm:ss'),
      width: 180,
    },
    {
      title: '创建时间',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => dayjs(text).format('YYYY-MM-DD HH:mm:ss'),
      width: 180,
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        return (
          <Space>
            <Typography.Link
              onClick={() => {
                setDrawerFormData(record)
                setIsDrawerOpen(true)
              }}
            >
              编辑
            </Typography.Link>
            <Divider style={{ marginInline: 0 }} type="vertical" />
            <Popconfirm
              title="提示"
              description="确认删除？"
              onConfirm={() => {
                deletePackage(record.id)
                  .then(() => {
                    message.success('删除成功')
                    fetchData()
                  })
                  .catch((err) => {
                    message.error(err?.message || '删除失败，请稍后再试～')
                  })
              }}
              okText="删除"
              cancelText="取消"
            >
              <Typography.Link type="danger">删除</Typography.Link>
            </Popconfirm>
          </Space>
        )
      },
      fixed: 'right',
      width: 150,
      align: 'center',
    },
  ])

  const addData = useCallback(() => {
    setIsDrawerOpen(true)
  }, [])
  const closeDrawer = useCallback(() => {
    setDrawerFormData({})
    setIsDrawerOpen(false)
  }, [])

  return (
    <Container>
      <div className="top">
        <Button
          style={{ marginRight: 12 }}
          type="primary"
          loading={loading}
          onClick={onSearch}
        >
          查询
        </Button>
        <Button onClick={addData}>新增</Button>
      </div>
      <div className="table">
        <Table
          rowKey="id"
          scroll={{ x: 2200 }}
          loading={loading}
          columns={columns.current}
          dataSource={dataSource}
        />
      </div>
      <div className="pagination"></div>
      <Drawer
        title={drawerFormData.id ? '编辑套餐' : '新增套餐'}
        open={isDrawerOpen}
        onClose={closeDrawer}
        width={450}
        destroyOnClose
      >
        <ModalForm data={drawerFormData} refreshTable={fetchData} />
      </Drawer>
    </Container>
  )
}

export default memo(Index)
